<template>
    <v-app id="inspire">
        <div class="details-wrap">
            <div class="details-header">
                <div class="details-header-back">
                    <p class="header-title title-name mb-0">Schedule for:<span class="headline"> {{ address }} </span><br>
                        <span class="upp"> {{ full_name }} </span>
                        <template v-if="pricing_plan_name">
                            on <span class="upp"> {{ pricing_plan_name }} </span>
                            <template v-if="service_plan_name">
                            - {{ service_plan_name }}
                            </template>
                        </template>
                    </p>
                    <v-btn class="header-btn-back mr-0 mb-3" @click="$router.go(-1)">
                    <v-icon class="header-btn-back-icon">navigate_before</v-icon>
                        Back
                    </v-btn>
                </div>
                <div style="clear: both;"></div>
                <v-layout class="xs12 wrap justify-end">
                    <v-menu offset-y bottom left>
                        <template v-slot:activator="{ on }">
                            <v-btn class="mr-0" v-on="on" icon>
                                <v-icon color="#999">more_vert</v-icon>
                            </v-btn>
                        </template>
                        <v-list class="pa-0">
                            <v-list-item @click="editGeolocationModal(location)">
                                <v-list-item-title><v-icon color="primary" class="mr-2">edit_location</v-icon> Adjust Geolocation</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-btn color="primary" dark class="mr-0" @click="assignLocationModal({location, service_days})">
                        <v-icon left>create</v-icon >
                        Edit Resource
                    </v-btn>
                </v-layout>
            </div>
            <v-card>
                <v-data-table
                        :headers="headers"
                        :items="items"
                        v-model="items"
                        :loading="loading"
                        loader-height="2"
                        class="elevation-1 details-table"
                        hide-default-footer
                        mobile-breakpoint="100">
                    <template v-slot:item="{item}">
                       <tr>
                            <td>Location ID</td>
                            <td>{{item.id}}</td>
                        </tr>
                        <tr>
                            <td>Client Name</td>
                            <td>{{item.full_name}}</td>
                        </tr>
                        <tr>
                            <td>Address</td>
                            <td>{{item.address}}</td>
                        </tr>
                        <tr>
                            <td>City</td>
                            <td>{{item.city}}</td>
                        </tr>
                        <tr>
                            <td>Zip</td>
                            <td>{{item.zip}}</td>
                        </tr>
                        <template v-if="item.recurring_assigned_to_name !== '' && item.recurring_start_date !== '' && item.recurring_estimate_time !== ''">
                            <template v-if="diferent_tech">
                                <tr v-for="(tech, key) in item.diferent_techs" :key="key">
                                    <td>{{ `Recurring Cleanup Assigned To (${days[Number(key.slice(-1))].short})` }}</td>
                                    <td>{{ tech.name }}</td>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td>Recurring Cleanup Assigned To</td>
                                    <td>{{ item.recurring_assigned_to_name }}</td>
                                </tr>
                            </template>
                            <tr>
                                <td>Start Recurring Cleanup Date</td>
                                <td>{{ item.recurring_start_date }}</td>
                            </tr>
                            <tr>
                                <td>Estimated Time for Recurring Cleanup</td>
                                <td>{{item.recurring_estimate_time}} {{item.recurring_estimate_time !== '' ? 'min' : ''}}</td>
                            </tr>
                            <tr>
                                <td>Service Days</td>
                                <td>{{ item.display_service_days }}</td>
                            </tr>
                        </template>
                        <template v-if="item.one_time_assigned_to_name !== '' && item.one_time_start_date !== '' && item.one_time_estimate_time !== ''">
                            <tr>
                                <td>One Time Cleanup Assigned To</td>
                                <td>{{ item.one_time_assigned_to_name }}</td>
                            </tr>
                            <tr>
                                <td>One Time Cleanup Date</td>
                                <td>{{ item.one_time_start_date }}</td>
                            </tr>
                            <tr>
                                <td>Estimated Time for One Time Cleanup</td>
                                <td>{{item.one_time_estimate_time}} {{item.one_time_estimate_time !== '' ? 'min' : ''}}</td>
                            </tr>
                        </template>
                        <tr v-if="item.service_plan_name!==null">
                            <td>Service Plan</td>
                            <td>{{item.service_plan_name}}</td>
                        </tr>

                        <tr v-if="item.pricing_plan_name!==null">
                            <td>Pricing Plan</td>
                            <td>{{item.pricing_plan_name}}</td>
                        </tr>

                        <tr v-if="item.subscription_stripe_id!==null">
                            <td>Subscription ID</td>
                            <td>
                                <v-layout v-if="!no_data.includes(item.subscription_id)" style="margin-left: -14px;">
                                    <v-menu bottom right d-inline-flex>
                                        <template v-slot:activator="{ on }">
                                            <v-btn class="ma-0" v-on="on" icon>
                                                <v-icon color="#999">more_vert</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list class="pa-0">
                                            <v-list-item @click="$router.push('/subscription/' + item.subscription_id + '/show')">
                                                <v-flex class="body-1">
                                                    <v-icon class="mr-2" color="primary" size="18px">visibility</v-icon> View Subscription Details
                                                </v-flex>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                    <v-layout class="wrap align-center">
                                        <v-flex>{{ item.subscription_id }}</v-flex>
                                    </v-layout>
                                </v-layout>
                                <em v-else class="grey--text">No data</em>
                            </td>
                        </tr>
                        <tr>
                            <td>Revenue Per Cleanup</td>
                            <td>{{`$ ${item.price}`}}</td>
                        </tr>
                        <template v-if="!no_data.includes(item.initial_assigned_to_name) || !no_data.includes(item.initial_start_date)">
                            <tr>
                                <td>Initial Cleanup Assigned To</td>
                                <td>{{ item.initial_assigned_to_name }}</td>
                            </tr>
                            <tr>
                                <td>Initial Cleanup Date</td>
                                <td>{{ item.initial_start_date }}</td>
                            </tr>
                            <tr>
                                <td>Estimated Time for Initial Cleanup</td>
                                <td>{{item.initial_estimate_time}} {{ item.initial_estimate_time !== '' ? 'min' : '' }}</td>
                            </tr>
                        </template>
                    </template>
                </v-data-table>

                <edit-unassigne-schedule @done="getDataFromApi"></edit-unassigne-schedule>
                <edit-geolocation @done="getDataFromApi"></edit-geolocation>   
            </v-card>
        </div>
    </v-app>
</template>

<script>
    import ApiService from "@/common/api.service";
    import EditUnassigneSchedule from '../EditUnassigneSchedule.vue'
    import EditGeolocation from '../EditGeolocation/EditGeolocation.vue'
    import { mapActions } from 'vuex'

    export default {
        name: 'ScheduleShow',
        components: {
            EditUnassigneSchedule,
            EditGeolocation
        },
        data() {
            return {
                items: [],
                recurring_service_days: [],
                initial_cleanup: [],
                one_time_cleanup: [],
                address: '',
                full_name: '',
                pricing_plan_name: '',
                service_plan_name: '',
                editGeolocationDialog: false,
                loading: true,
                no_data: [null, '', undefined, 'null'],
                headers: [
                    {
                        text: 'Details',
                        align: 'left',
                        sortable: false,
                        value: 'conditions'
                    },
                    {
                        text: '',
                        value: 'results',
                        sortable: false
                    }
                ],
                service_plan: '',
                days: {
                    "1": { name: 'Monday', short: 'Mon'},
                    "2": { name: 'Tuesday', short: 'Tue'},
                    "3": { name: 'Wednesday', short: 'Wed'},
                    "4": { name: 'Thursday', short: 'Thu'},
                    "5": { name: 'Friday', short: 'Fri'},
                    "6": { name: 'Saturday', short: 'Sat'},
                    "7": { name: 'Sunday', short: 'Sun'},
                },
                two_times_a_month_weeks: {
                    "1": { name: '1st and 3rd Week'},
                    "2": { name: '2nd and 4th Week'}
                },
                bi_weeks: {
                    1: '1st and 3rd Week',
                    2: '2nd and 4th Week'
                },
                weeks: {
                    1: '1st Week',
                    2: '2nd Week',
                    3: '3rd Week',
                    4: '4th Week'
                },
                diferent_tech: false,
                location: {}
            }
        },
        mounted() {
            this.getDataFromApi()
        },
        methods: {
            ...mapActions(['vEmit']),
            getDataFromApi(id = this.$route.params.id) {
                this.loading = true

                ApiService.get('/scheduler/show' , {"id":id})
                    .then(response => {
                        this.location = response.data.location
                        this.service_days = response.data.service_days

                        this.items = [{...response.data.location}]
                        // this.service_days = data.service_days;

                        this.recurring_service_days = response.data.service_days.filter(i => i.service_type === 'recurring');
                        this.initial_cleanup = response.data.service_days.filter(i => i.service_type === 'initial');
                        this.one_time_cleanup = response.data.service_days.filter(i => i.service_type === 'one_time');

                        if(this.recurring_service_days.length > 0) {
                            let techs = this.recurring_service_days.map(i => i.assigned_to_id)
                            if(Boolean(this.location.commercial)) {
                                this.recurring_service_days = _.groupBy(this.recurring_service_days, "day");
                                this.recurring_service_days = Object.values(this.recurring_service_days).map(i => {
                                    let item = { ...i[0] }
                                    item.assigned_to_name = i.map(el => el.assigned_to_name)
                                    item.assigned_to_id = i.map(el => el.assigned_to_id)
                                    return item
                                })
                                techs = this.recurring_service_days.map(i => i.assigned_to_id.join(','))
                            }

                            let uniqueTechs = [...new Set(techs)]
                            if (uniqueTechs.length > 1) {
                                this.items[0].diferent_techs = {}
                                this.recurring_service_days.forEach(d => {
                                    if(Boolean(this.location.commercial)) {
                                        this.items[0].diferent_techs[`assigned_to_${d.day}`] = { name: d.assigned_to_name.join(', '), id: d.assigned_to_id.join(',') }
                                    } else {
                                        this.items[0].diferent_techs[`assigned_to_${d.day}`] = { name: d.assigned_to_name, id: d.assigned_to_id }
                                    }
                                })
                                this.diferent_tech = true
                            }
                            
                            if(Boolean(this.location.commercial)) {
                                this.items[0].recurring_assigned_to_name = this.recurring_service_days[0].assigned_to_name.join(', ');
                                this.items[0].recurring_assigned_to_id = this.recurring_service_days[0].assigned_to_id.join(',');
                            } else {
                                this.items[0].recurring_assigned_to_name = this.recurring_service_days[0].assigned_to_name;
                                this.items[0].recurring_assigned_to_id = this.recurring_service_days[0].assigned_to_id; 
                            }
                            this.items[0].recurring_start_date = this.recurring_service_days[0].start_date;
                            this.items[0].recurring_estimate_time = this.recurring_service_days[0].estimate_time;
                            this.items[0].day = this.recurring_service_days[0].day;
                            this.items[0].week = this.recurring_service_days[0].week;
                            this.items[0].service_id = this.recurring_service_days[0].service_id;

                            this.items[0].display_service_days = [];
                            this.items[0].recurring_service_days = [];

                            if (this.location.service_plan_slug.includes('a_week')) {
                                this.items[0].display_service_days = this.recurring_service_days.map(i => this.days[i.day].name).join(', ')
                            } else if (this.location.service_plan_slug === 'twice_per_month' || this.location.service_plan_slug === 'once_a_month') {
                                this.items[0].display_service_days = this.recurring_service_days.map(i => `${this.weeks[i.week]} - ${this.days[i.day].name}`).join(', ')
                            } else if (this.location.service_plan_slug === 'bi_weekly') {
                                this.items[0].display_service_days = `${Number(this.recurring_service_days[0].week)%2 === 0 ? 'Even weeks in year' : 'Odd weeks in year'} - ${this.days[this.recurring_service_days[0].day].name}`
                            }

                            this.recurring_service_days.forEach(day => {
                                let service_day = {};
                                service_day.name = this.days[day.day].name
                                service_day.day_id = day.day;
                                service_day.service_id = day.service_id;
                                this.items[0].recurring_service_days.push(service_day);
                            });
                        } else {
                            this.items[0].recurring_assigned_to_name = '';
                            this.items[0].recurring_assigned_to_id = '';
                            this.items[0].recurring_start_date = '';
                            this.items[0].recurring_estimate_time = '';
                            this.items[0].display_service_days = [];
                            this.items[0].recurring_service_days = [];
                        }

                        if(this.initial_cleanup.length > 0) {
                            if(Boolean(this.location.commercial)) {
                                this.initial_cleanup = _.groupBy(this.initial_cleanup, "day");
                                this.initial_cleanup = Object.values(this.initial_cleanup).map(i => {
                                    let item = { ...i[0] }
                                    item.assigned_to_name = i.map(el => el.assigned_to_name)
                                    item.assigned_to_id = i.map(el => el.assigned_to_id)
                                    return item
                                })
                                this.items[0].initial_assigned_to_name = this.initial_cleanup[0].assigned_to_name.join(', ');
                                this.items[0].initial_assigned_to_id = this.initial_cleanup[0].assigned_to_id.join(',');
                            } else {
                                this.items[0].initial_assigned_to_name = this.initial_cleanup[0].assigned_to_name;
                                this.items[0].initial_assigned_to_id = this.initial_cleanup[0].assigned_to_id;
                            }
                            this.items[0].initial_service_id = this.initial_cleanup[0].service_id;
                            this.items[0].initial_start_date = this.initial_cleanup[0].start_date;
                            this.items[0].initial_estimate_time = this.initial_cleanup[0].estimate_time;
                        } else {
                            this.items[0].initial_service_id = '';
                            this.items[0].initial_assigned_to_name = '';
                            this.items[0].initial_assigned_to_id = '';
                            this.items[0].initial_start_date = '';
                            this.items[0].initial_estimate_time = '';
                        }

                        if(this.one_time_cleanup.length > 0) {
                            // this.items[0].one_time_assigned_to_name = this.one_time_cleanup[0].assigned_to_name;
                            // this.items[0].one_time_assigned_to_id = this.one_time_cleanup[0].assigned_to_id;
                            let techs = this.one_time_cleanup.map(i => i.assigned_to_id)
                            if(Boolean(this.location.commercial)) {
                                this.one_time_cleanup = _.groupBy(this.one_time_cleanup, "day");
                                this.one_time_cleanup = Object.values(this.one_time_cleanup).map(i => {
                                    let item = { ...i[0] }
                                    item.assigned_to_name = i.map(el => el.assigned_to_name)
                                    item.assigned_to_id = i.map(el => el.assigned_to_id)
                                    return item
                                })
                                techs = this.one_time_cleanup.map(i => i.assigned_to_id.join(','))
                            }

                            let uniqueTechs = [...new Set(techs)]
                            if (uniqueTechs.length > 1) {
                                this.items[0].diferent_techs = {}
                                this.one_time_cleanup.forEach(d => {
                                    if(Boolean(this.location.commercial)) {
                                        this.items[0].diferent_techs[`assigned_to_${d.day}`] = { name: d.assigned_to_name.join(', '), id: d.assigned_to_id.join(',') }
                                    } else {
                                        this.items[0].diferent_techs[`assigned_to_${d.day}`] = { name: d.assigned_to_name, id: d.assigned_to_id }
                                    }
                                })
                                this.diferent_tech = true
                            }
                            
                            if(Boolean(this.location.commercial)) {
                                this.items[0].one_time_assigned_to_name = this.one_time_cleanup[0].assigned_to_name.join(', ');
                                this.items[0].one_time_assigned_to_id = this.one_time_cleanup[0].assigned_to_id.join(',');
                            } else {
                                this.items[0].one_time_assigned_to_name = this.one_time_cleanup[0].assigned_to_name;
                                this.items[0].one_time_assigned_to_id = this.one_time_cleanup[0].assigned_to_id; 
                            }

                            this.items[0].one_time_service_id = this.one_time_cleanup[0].service_id;
                            this.items[0].one_time_start_date = this.one_time_cleanup[0].start_date;
                            this.items[0].one_time_estimate_time = this.one_time_cleanup[0].estimate_time;
                        } else {
                            this.items[0].one_time_service_id = '';
                            this.items[0].one_time_assigned_to_name = '';
                            this.items[0].one_time_assigned_to_id = '';
                            this.items[0].one_time_start_date = '';
                            this.items[0].one_time_estimate_time = '';
                        }

                        this.address = this.items[0].address;
                        this.full_name = this.items[0].full_name;
                        this.pricing_plan_name = this.items[0].pricing_plan_name;
                        this.service_plan_name = this.items[0].service_plan_name;
                        this.loading = false;
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            assignLocationModal(item){
                this.vEmit({ name: 'ScheduleLocation', data: item })
            },
            editGeolocationModal(item){
                this.vEmit({ name: 'EditGeoLocation', data: item })
            },

            //Remove under score from string
            removeUnderScore(str){
                for(let i in str){
                str = str.replace('_', ' ');
                }
                return str
            }
        }

    }
</script>

<style scoped>
    /*Remove action controls form table*/
  .details-wrap .datatable__actions {
    display: none;
  }

  .upp {
    text-transform: uppercase;
  }

    .dialog-heading {
    background-color: #efefef;
    padding: 10px;
    }

</style>
